import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TCService } from '@macs-frontend/features/company-management/team-cost/team-cost.types';

@Component({
  selector: 'md-teamcost-service',
  templateUrl: './service.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceComponent implements OnInit {
  @Input() items: TCService[] = [];
  @Input() title = '';
  @Input() total?: number = 0;
  @Input() currencySign = '';

  constructor() {}

  ngOnInit(): void {}

  getTotal(): number {
    return this.total ?? 0;
  }
}
